import { CurationStore } from '../types/curation';
import { Restaurant } from '../types/restaurant';

/**
 * CurationStore를 Restaurant 타입으로 변환
 * @param store CurationStore 객체
 * @returns Restaurant 객체
 */
export const convertCurationStoreToRestaurant = (store: CurationStore): Restaurant => {
  return {
    // 기본 식별 정보
    id: store.id,
    restaurantId: parseInt(store.id.replace(/\D/g, '')) || 0, // 숫자만 추출, 없으면 0
    
    // 기본 정보
    name: store.name,
    address: store.address,
    phone: '', // CurationStore에 없는 필드
    serviceCenterNumber: '', // CurationStore에 없는 필드
    lat: store.lat,
    lng: store.lng,
    logoUrl: store.logoUrl,
    backgroundUrl: store.backgroundUrl,
    introductionTitle: store.description || '', // description을 title로 사용
    
    // 프랜차이즈 정보
    franchiseId: store.franchiseId,
    franchiseName: store.franchiseName,
    
    // 평가 정보
    reviewAvg: store.reviewAvg || 0,
    reviewCount: store.reviewCount || 0,
    
    // 운영 정보
    distance: store.distance,
    isOpen: store.isOpen,
    minOrderAmount: store.minOrderAmount,
    categories: store.categories,
    servingType: null,
    
    // 통화별 최소 주문금액
    minOrderAmountKrw: store.minOrderAmountKrw,
    minOrderAmountUsd: store.minOrderAmountUsd,
    minOrderAmountJpy: store.minOrderAmountJpy,
    minOrderAmountCny: store.minOrderAmountCny,
    minOrderAmountTwd: store.minOrderAmountTwd,
    
    // 다국어 정보
    nameEn: store.nameEn || null,
    nameKo: store.nameKo || null,
    nameJa: store.nameJa || null,
    nameZhCn: store.nameZhCn || null,
    nameZhTw: store.nameZhTw || null,
    addressEn: store.addressEn || null,
    addressJa: store.addressJa || null,
    addressZhCn: store.addressZhCn || null,
    addressZhTw: store.addressZhTw || null,
    introductionTitleEn: store.descriptionEn || null,
    introductionTitleKo: store.descriptionKo || null,
    introductionTitleJa: store.descriptionJa || null,
    introductionTitleZhCn: store.descriptionZhCn || null,
    introductionTitleZhTw: store.descriptionZhTw || null,
    
    // 기타
    hasTranslation: Boolean(store.nameEn || store.nameJa || store.nameZhCn || store.nameZhTw)
  };
}; 